import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        navNo:0,//任务清单OR学习记录切换
        allowBack:true,//页面是否允许返回的开关
        navSelNo:0,//左侧大导航的index
        isScoreList:false,//标识是否从任务跳转至成绩列表
        isLogin:false,//是否登錄
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js